import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class SiteNavsService extends DatabaseGwService {
  URL_PATH: string = "/site-navs";
}
